var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_vm._v("若未自动跳转，请点击"),_c('a',{on:{"click":_vm.redirect}},[_vm._v("这里")])])}
var staticRenderFns = []

export { render, staticRenderFns }